(function () {
  'use strict';

  /* @ngdoc object
   * @name leaveReport
   * @description
   *
   */
  angular
    .module('leaveReport', [
      'ui.router'
    ]);
}());
